/**
 * Contratos de feature flags (Unleash).
 *
 * El contexto de evaluación es DELIBERADAMENTE un mapeo campo por campo y no un spread
 * del token: el claim `permisos` del `tokenPermisos` trae `Ruts` (y otros datos
 * personales) mezclados con los campos útiles, y todo lo que entre acá viaja a Unleash.
 */

/** Contexto que viaja a Unleash. Sin datos personales — ver la nota de arriba. */
export interface FlagContext {
  /** `IdUsuario` del token. Fija el stickiness por persona en rollouts por porcentaje. */
  userId?: string;
  IdEmpresa?: number;
  IdOrganizacion?: number;
  Pais?: string;
}

/** De dónde salió el valor de un flag. Útil para diagnosticar en consola. */
export type FuenteFlag = 'unleash' | 'environment';

/**
 * Flag de prueba de la integración. No cambia ningún comportamiento: solo se informa en
 * consola al arrancar, para certificar de punta a punta que Unleash responde y que
 * encender/apagar desde la consola se refleja en la app. Se puede borrar cuando exista
 * el primer flag real.
 */
export const FLAG_PRUEBA_UNLEASH = 'cotizaciones-prueba-unleash';
